<template>
  <v-container>
    <div class="page calculating" v-if="calculating">
      <v-row>
        <v-col cols="12" class="d-flex align-center justify-center">
          <div class="calculating_block">
            <v-card transition="slide-x-transition">
              <v-card-text>
                <div class="drawer_frame">
                  <SmilesSvgDrawer
                    :id="`preview_load`"
                    :smiles="compound"
                    :width="290"
                    :height="290"
                    class="drawer"
                    ref="element"
                  ></SmilesSvgDrawer>
                </div>
                <div class="start_txt">
                  <div class="start_smiles d-flex align-center justify-center">
                    <div>{{ compound }}</div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <h2>Calculating the ADMET/PK result…</h2>
            <v-progress-linear
              color="primary"
              height="10"
              :value="progress"
              striped
            ></v-progress-linear>
            <div class="row d-flex justify-space-between calculating_number">
              <v-col><span>0%</span></v-col>
              <v-col class="text-right"
                ><span>{{ progress }}%</span></v-col
              >
            </div>
            <div class="calculating_deco">
              <div>H-bond acceptors</div>
              <div>Water solubility</div>
              <div>Clearance</div>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="list-item-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="list-item-two-line"
              ></v-skeleton-loader>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="page explainable" v-else>
      <v-row class="d-flex align-stretch">
        <v-col class="col-md-4 col-sm-12">
          <v-tabs class="explainable_tabs explainable_tabs2 justify-center mb">
            <v-tab @click="togglePanel1(0)">Structure</v-tab>
            <v-tab @click="togglePanel1(1)">SMILES</v-tab>
          </v-tabs>
          <div
            v-show="openSmiles == 0"
            class="explainable_drawer frame frame-50 px-0 py-0"
          >
            <div class="drawer_frame">
              <SmilesSvgDrawer
                :id="`preview`"
                :smiles="compound"
                :width="290"
                :height="290"
                class="drawer"
                ref="element"
              ></SmilesSvgDrawer>
            </div>
          </div>
          <div
            v-show="openSmiles == 1"
            class="explainable_smiles frame frame-50"
          >
            <div class="d-flex align-center justify-center fill-height">
              <div>
                <div class="highlight" v-html="atom || compound"></div>
              </div>
            </div>
          </div>
        </v-col>
        <v-tabs class="explainable_tabs justify-center mb">
          <v-tab @click="togglePanel2(0)">Explainable AI</v-tab>
          <v-tab @click="togglePanel2(1)">ADMET/PK prediction</v-tab>
        </v-tabs>
        <v-col
          v-show="openAnalysis == 0"
          class="col-md-4 col-sm-12 explainable_ai"
        >
          <div class="frame_title">
            <div>
              <h3 v-text="$t('explainable.explainable_ai')"></h3>
              <h4>Toxicity</h4>
            </div>
          </div>
          <div class="frame explainable_tox pt-12">
            <v-row class="pt-12">
              <v-col
                class="col-12 col-lg-6"
                v-for="(item, i) in toxicity"
                :key="i"
              >
                <v-card
                  :class="{ frame_card: true, active: curr == i }"
                  align="center"
                  @click="toggleAnalysis(item.endpoint, i)"
                  :disabled="(result[item.endpoint] || {}).value != 'Yes'"
                >
                  <!-- <div class="frame_icon">
                    <v-icon
                      v-show="curr != i"
                      class="frame_icon_false"
                      size="18"
                      >mdi-radiobox-blank</v-icon
                    >
                    <v-icon
                      v-show="curr == i"
                      class="frame_icon_true"
                      size="18"
                      color="#D56A51"
                      >mdi-radiobox-marked</v-icon
                    >
                  </div> -->
                  <strong
                    class="frame_value"
                    v-if="
                      item.visible == true &&
                      (result[item.endpoint] || {}).value != undefined
                    "
                    >{{
                      (result[item.endpoint] || {}).analysis != undefined
                        ? "Yes"
                        : "No"
                    }}</strong
                  ><strong v-else-if="item.visible == true"
                    ><v-progress-circular
                      indeterminate
                      size="18"
                      width="3"
                      color="#bebebe"
                    ></v-progress-circular
                  ></strong>
                  <strong class="frame_value" v-else>- - -</strong>
                  <div class="frame_btn">
                    <span
                      class="btn_touch2"
                      v-show="
                        curr != i &&
                        (result[item.endpoint] || {}).value == 'Yes'
                      "
                      v-text="$t('explainable.touch_to_view')"
                    ></span>
                  </div>
                  <div class="frame_unit d-flex align-center justify-center">
                    <span>{{ item.endpointName || "- - -" }}</span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col
          v-show="openAnalysis == 1"
          class="col-md-4 col-sm-12 explainable_prediction"
        >
          <div class="frame_title">
            <div>
              <h3 v-text="$t('explainable.admet')"></h3>
              <v-row class="results-row">
                <v-col cols="7"
                  ><span v-text="$t(`explainable.endpoint`)"></span
                ></v-col>
                <v-col cols="5"
                  ><span v-text="$t(`explainable.value`)"></span
                ></v-col>
              </v-row>
            </div>
          </div>
          <div class="frame results explainable_results" align="center">
            <v-col
              cols="12"
              v-for="ep in predictionTop"
              :key="ep.endpoint"
              class="results-row"
            >
              <v-row>
                <v-col
                  cols="7"
                  :class="{
                    'orange--text': ep.property == true,
                    'black--text': ep.property != true,
                  }"
                  ><b v-html="ep.endpointName"></b
                ></v-col>
                <v-col
                  cols="5"
                  :class="{
                    'orange--text': ep.property == true,
                    'black--text': ep.property != true,
                  }"
                  ><b v-if="(result[ep.endpoint] || {}).value != undefined">{{
                    (result[ep.endpoint] || {}).value
                  }}</b>
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="18"
                    width="3"
                    color="#bebebe"
                  ></v-progress-circular
                ></v-col>
              </v-row>
            </v-col>
            <v-row v-for="(item, i) in prediction" :key="i" class="results-row">
              <v-col cols="7">
                <strong v-if="item[0].property != true">{{
                  item[0].categoryName
                }}</strong></v-col
              >
              <v-col cols="5"></v-col>

              <v-col cols="12" v-for="(ep, j) in item" :key="j">
                <v-row>
                  <v-col
                    cols="7"
                    :class="{ 'result-visible': ep.visible == true }"
                    ><b>{{ ep.endpointName }}</b
                    ><br />({{ ep.unitName }})</v-col
                  >
                  <v-col
                    cols="5"
                    :class="{ 'result-visible': ep.visible == true }"
                    ><b
                      v-if="
                        ep.visible == true &&
                        (result[ep.endpoint] || {}).value != undefined
                      "
                      >{{ (result[ep.endpoint] || {}).value }}</b
                    >
                    <v-progress-circular
                      v-else-if="
                        ep.visible == true &&
                        (result[ep.endpoint] || {}).value == undefined
                      "
                      indeterminate
                      size="18"
                      width="3"
                      color="#bebebe"
                    ></v-progress-circular>
                    <b v-else>- - -</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <div class="explainable_bottom">
        <v-container>
          <div class="frame frame-bottom">
            <v-row class="align-center justify-center">
              <v-col class="col-md-5 col-12"
                ><h3>Compound optimization</h3></v-col
              >
              <v-col class="col-md-4 col-6 text-center">
                <div class="select_block">
                  <select class="v-input" v-model="selectProperty">
                    <option value="-1">Select property</option>
                    <option value="0" key="logP (Wildman-Crippen)">
                      logP (Wildman-Crippen)
                    </option>
                    <option value="1" key="logP (VIRTUALMAN)">
                      logP (VIRTUALMAN)
                    </option>
                    <option value="2" key="Mutagenicity">Mutagenicity</option>
                    <option value="3" key="logP (VIRTUALMAN) + Mutagenicity">
                      logP (VIRTUALMAN) + Mutagenicity
                    </option>
                  </select>
                  <v-icon size="30">mdi-chevron-down</v-icon>
                </div>
              </v-col>
              <v-col class="col-md-3 col-6 text-center">
                <v-btn
                  class="btn_optimize"
                  color="#D56A51"
                  @click="sendProperty"
                  :loading="optimizing"
                  :disabled="selectProperty == -1 || isComplete == false"
                >
                  <span v-text="$t('explainable.optimize_property')"></span>
                  <v-icon size="30" class="ml-2">mdi-arrow-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </div>
    </div>
    <HintTag></HintTag>
  </v-container>
</template>

<script>
import SmilesSvgDrawer from "@/components/SmilesSvgDrawer";
import Compounds from "@/components/Compounds";
import HintTag from "@/components/HintTag";

export default {
  name: "Explainable",
  mixins: [Compounds],
  components: {
    SmilesSvgDrawer,
    HintTag,
  },
  data() {
    return {
      openSmiles: false,
      openAnalysis: false,
      curr: -1,
      atom: null,
      calculating: false,
      optimizing: false,
      progress: 0,
      selectProperty: -1,
      screening: null,
      currentEp: "mutagenicity",
    };
  },
  computed: {
    id() {
      return (this.$route.query || {}).id || 0;
    },
    request() {
      return (this.screening || {}).request || {};
    },
    compound() {
      return ((this.request.compounds || [])[0] || {}).canonical;
    },
    result() {
      return Object.values((this.screening || {}).result || {})
        .filter((e) => e.smiles == this.compound)
        .reduce((p, c) => {
          p[c.endpoint] = {
            ...c,
            value: this.getDisplayValue(c),
          };
          return p;
        }, {});
    },
    endpoints() {
      return this.endpointsList || {};
    },
    logp() {
      return this.result.find((e) => e.endpoint == "logp");
    },
    predictionTop() {
      return Object.values(
        Object.values(this.endpoints || {}).filter(
          (e) =>
            e.endpoint == "logp" ||
            e.endpoint == "logp_v" ||
            e.endpoint == "mutagenicity"
        ) || {}
      );
    },
    prediction() {
      return (
        Object.values(
          Object.values(this.endpoints || {})
            .filter(
              (e) =>
                e.endpoint != "logp" &&
                e.endpoint != "logp_v" &&
                e.endpoint != "mutagenicity"
            )
            .reduce((p, c) => {
              if (c.category != undefined) {
                if (p[c.categoryId] == undefined) p[c.categoryId] = [];
                p[c.categoryId].push(c);
              }
              return p;
            }, {}) || {}
        ).sort((a, b) => {
          return a.categoryId - b.categoryId;
        }) || []
      );
    },
    toxicity() {
      return [
        this.endpointsList["mutagenicity"],
        this.endpointsList["herg"],
        this.endpointsList["cytotoxicity"],
        this.endpointsList["hepatotoxicity"],
      ];
    },
    analysis() {
      return {
        mutagenicity: (this.result["mutagenicity"] || {}).analysis || [],
      };
    },
    isComplete(){
      return Object.values(this.result).length == 6;
    }
  },
  methods: {
    togglePanel1(tab) {
      this.openSmiles = tab;
    },
    togglePanel2(tab) {
      this.openAnalysis = tab;
    },
    toggleAnalysis(ep, i) {
      this.curr = i;
      this.updateAnalysis(ep);
      try {
        this.$refs.element.markerInit();
      } catch (error) {
        console.log(error);
      }
    },
    // loadProgress() {
    //   if (this.progress != 100) {
    //     this.progress += 4;
    //     return setTimeout(() => {
    //       this.loadProgress();
    //     }, 200);
    //   } else {
    //     this.calculating = false;
    //   }
    // },
    sendProperty() {
      if (this.selectProperty < 0) return;
      this.optimizing = true;
      let data = {
        property: this.selectProperty,
        smiles: this.compound,
        originId: this.$route.params.id || "",
      };
      const token = this.$root.userToken;
      this.$ajax(this.$root.api + "/optimize", {
        method: "post",
        headers: {
          Authorization: token,
          "Content-Type": "application/json; charset=UTF-8",
        },
        data: data,
      })
        .then((res) => {
          if (res.data != false) {
            let d = JSON.parse(JSON.stringify(res.data || [])) || {};
            this.$root.optimizeId = d;
            setTimeout(() => {
              this.$router.push(`/optimization/${d}`);
            }, 3000);
          } else {
            this.$root.$somethingWrong(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  mounted() {
    let originId = this.$route.params.id;
    this.$root.explainId = originId;
    if (this.screening == null && originId != undefined) {
      this.$db.ref(`userTasks/demo/${originId}`).on("value", (snapshot) => {
        if (snapshot.exists()) {
          this.screening = snapshot.val() || {};
        }
      });
    }
  },
};
</script>
